import React from "react";

export default function Stats({data}) {

  return (
    <div className="stats-container">
      <div className="stats-heading">
        Stats
      </div>
      <table className="stats-table">
        <thead>
          <tr className="table-head">
            <th style={{ borderTopLeftRadius: "10px" }}>Clients</th>
            <th>Respondents</th>
            <th>Completed</th>
            <th style={{ borderTopRightRadius: "10px" }}>Pending</th>
          </tr>
        </thead>
        <tbody className="table-body">
          <tr>
            <td>
              <p>{data.clients}</p>
            </td>
            <td>
              <p>{data.respondents}</p>
            </td>
            <td>
              <p>{data.completions}</p>
            </td>
            <td>
              <p>{data.pending}</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
